import { render, staticRenderFns } from "./SafeSet.vue?vue&type=template&id=ddc9b1fc&scoped=true"
import script from "./SafeSet.vue?vue&type=script&lang=js"
export * from "./SafeSet.vue?vue&type=script&lang=js"
import style0 from "./SafeSet.vue?vue&type=style&index=0&id=ddc9b1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc9b1fc",
  null
  
)

export default component.exports